import React from "react";
import { TabView, TabPanel } from "primereact/tabview";

export default function ReusableTabView({ tabs }) {
  return (
    <div className="card">
      <TabView>
        {tabs.map((tab) => (
          <TabPanel key={tab.header} header={tab.header}>
            <div className="m-0">{tab.content}</div>
          </TabPanel>
        ))}
      </TabView>
    </div>
  );
}
